/**
 * Predictive search
 */
(function () {
  const settings = window.themeSettings || {};
  if (!settings.predictiveSearch) return;

  const debounce = window.Alverio.debounce;

  document.querySelectorAll('[data-predictive-search-input]').forEach((input) => {
    const form = input.closest('form');
    const resultsId = form?.parentElement?.querySelector('[id^="PredictiveSearchResults"]')?.id;
    const resultsEl = resultsId ? document.getElementById(resultsId) : null;

    const fetchResults = debounce(async (query) => {
      if (!query || query.length < 2) {
        resultsEl?.classList.add('hidden');
        return;
      }

      try {
        const url = `${settings.routes.predictiveSearch}?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6`;
        const res = await fetch(url);
        const data = await res.json();
        renderResults(data, resultsEl, query);
      } catch {
        resultsEl?.classList.add('hidden');
      }
    }, 250);

    input.addEventListener('input', (e) => fetchResults(e.target.value.trim()));
    input.addEventListener('focus', (e) => fetchResults(e.target.value.trim()));

    document.addEventListener('click', (e) => {
      if (!form?.contains(e.target)) resultsEl?.classList.add('hidden');
    });
  });

  function renderResults(data, el, query) {
    if (!el) return;
    const products = data.resources?.results?.products || [];
    if (products.length === 0) {
      el.classList.add('hidden');
      return;
    }

    el.innerHTML = products
      .map(
        (p) =>
          `<a href="${p.url}" role="option" style="display:block;padding:0.75rem 1rem;border-bottom:1px solid var(--color-border);">${p.title}</a>`
      )
      .join('');
    el.classList.remove('hidden');
    el.style.cssText = 'position:absolute;background:var(--color-background);border:1px solid var(--color-border);border-radius:var(--radius-card);width:100%;max-width:640px;z-index:100;margin-top:0.25rem;box-shadow:0 8px 24px rgba(0,0,0,0.08);';
  }
})();
